import { AREA_MASTER } from "constants/areaMaster";

import type { Props } from "../../../../props";

type Area = Props["groupedPrefectures"][number];

const OTHER_CODE = AREA_MASTER.others.code;

export const convertStateForPrefectureCheckbox =
  (code: string) =>
  (area: Area): Area => {
    if (area.code === OTHER_CODE) return area;

    const prefectures = area.prefectures.map((prefecture) => {
      const { code: prefectureCode, isPrefectureChecked } = prefecture;
      if (prefectureCode !== code) return prefecture;
      return {
        ...prefecture,
        isPrefectureChecked: !isPrefectureChecked,
      };
    });

    const isAllPrefectureChecked =
      prefectures.length > 0 &&
      prefectures.every(({ isPrefectureChecked }) => isPrefectureChecked);

    return {
      ...area,
      isAreaChecked: isAllPrefectureChecked,
      prefectures,
    };
  };
